"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M0.999146 0.499023C0.999146 0.222881 0.775288 -0.000976562 0.499146 -0.000976562C0.223003 -0.000976562 -0.000854492 0.222881 -0.000854492 0.499023V11.279C-0.000854492 11.6627 0.304621 12.0007 0.714083 12.0007H11.5008C11.777 12.0007 12.0008 11.7769 12.0008 11.5007C12.0008 11.2246 11.777 11.0007 11.5008 11.0007H0.999146V0.499023ZM11.6015 1.04586C11.7048 0.789778 11.581 0.498419 11.3249 0.39509C11.0688 0.291762 10.7775 0.415593 10.6741 0.671674L8.67327 5.63046L5.5159 3.96078C5.39516 3.89693 5.25356 3.88525 5.12399 3.92845C4.99443 3.97166 4.88817 4.06599 4.82992 4.18953L3.04161 7.98206C2.92383 8.23182 3.03083 8.52977 3.2806 8.64755C3.53037 8.76532 3.82832 8.65832 3.94609 8.40855L5.51116 5.08948L8.69579 6.77359C8.82092 6.83976 8.96823 6.84979 9.10118 6.8012C9.23412 6.75261 9.34024 6.64994 9.39321 6.51868L11.6015 1.04586Z"
}));

exports["default"] = _default;